const Credit = () => {
  return (
    <div
      style={{
        position: "absolute",
        bottom: "2%",
        left: 0,
        zIndex: 1,
        marginLeft: 15,
        marginTop: 15,
        padding: "1em",
        width: 100,
        color: "#000",
        background: "rgba(255, 255, 255, 0.2)",
        borderRadius: ".8em",
        fontSize: 12,
        lineHeight: 1.2,
        cursor: "pointer",
      }}
      onClick={() => (window.location.href = "/about")}
    >
      <h4
        style={{
          color: "white",
          fontWeight: "bolder",
        }}
      >
        By Dreem
      </h4>
    </div>
  );
};

export default Credit;
